import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\EstablishMetadataInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/EstablishMetadataInvoiceController.php
* @route '/api/invoicing/{invoice}/establish'
*/
const EstablishMetadataInvoiceController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: EstablishMetadataInvoiceController.url(args, options),
    method: 'get',
})

EstablishMetadataInvoiceController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/establish',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\EstablishMetadataInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/EstablishMetadataInvoiceController.php
* @route '/api/invoicing/{invoice}/establish'
*/
EstablishMetadataInvoiceController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return EstablishMetadataInvoiceController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\EstablishMetadataInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/EstablishMetadataInvoiceController.php
* @route '/api/invoicing/{invoice}/establish'
*/
EstablishMetadataInvoiceController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: EstablishMetadataInvoiceController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\EstablishMetadataInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/EstablishMetadataInvoiceController.php
* @route '/api/invoicing/{invoice}/establish'
*/
EstablishMetadataInvoiceController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: EstablishMetadataInvoiceController.url(args, options),
    method: 'head',
})

export default EstablishMetadataInvoiceController